import supHttps from '../init/supHttps';

//SUP-ADM-SP-01 get a list of generated payouts to be approved
export async function listPayouts(type, status, limit, offset) {
    const result = await supHttps.get(
        `/support/admin/super/payouts/${type}?approval=${status}&limit=${limit}&offset=${offset}`
    );
    return result;
}

//SUP-ADM-SP-02 Approve payout
export async function approvePayout(type, payoutId) {
    const result = await supHttps.patch(`/support/admin/super/payouts/approve/${type}/${payoutId}`);
    return result;
}

//SUP-ADM-SP-03 Dis-Approve payout
export async function disApprovePayout(type, payoutId) {
    const result = await supHttps.patch(`/support/admin/super/payouts/not-approve/${type}/${payoutId}`);
    return result;
}

//SUP-ADM-SP-04 Payout count
export async function payoutCountFun(type, status) {
    const result = await supHttps.get(`/support/admin/super/payouts/count/${type}?status=${status}`);
    return result;
}

//SUP-ADM-SP-05 Assign a chat user to a support agent
export async function assignChatUser(id, supportUserId) {
    const result = await supHttps.put(`/support/admin/super/chat-users/${id}/assign`, {
        supportUserId
    });
    return result;
}

//SUP-ADM-SP-06 Get the assignment history for a chat user
export async function getAssignHistory(id) {
    const result = await supHttps.get(`/support/admin/super/chat-users/${id}/assignment-history`);
    return result;
}

//SUP-ADM-SP-07 Get list of support users a chat can be assigned to
export async function getAssignableSupUsers(id) {
    const result = await supHttps.get(`/support/admin/super/support-users/assignable`);
    return result;
}
